export const SLOW_POLLING_DELAY = 60000; //1min
export const FAST_POLLING_DELAY = 10000; //10 secs
